import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import IntroJs from 'intro.js'
import 'intro.js/introjs.css'
import { VueAxios } from '@/utils/request' // axios 不建议引入到 Vue 原型链上
import VueAreaLinkage from 'vue-area-linkage'
import './core/use'
import bootstrap from './core/bootstrap'
import '@/permission' // permission control
import '@/utils/filter' // global filter
import global_variable from '@/utils/global_variable.js'
//转盘
import VueLuckyCanvas from '@lucky-canvas/vue'

import { EventBus } from './event-bus'

Vue.config.productionTip = false

Vue.prototype.$_c = process.env.BASE_URL

Vue.prototype.global = global_variable

Vue.use(VueAxios, router,IntroJs)

Vue.use(VueAreaLinkage)

Vue.use(VueLuckyCanvas)

new Vue({
  router,
  store,
  IntroJs,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
